import * as router from "hassibot/internal-router";

// Order matters: the first match wins, so a nested list view (e.g. the
// caregiver broadcasts list) must appear before the list view it is nested
// under (the caregiver list).
const REDIRECTION_LIST_VIEWS = [
  router.proclientAppRouter.list(),
  router.caregiverAppRouter.broadcastList(),
  router.caregiverAppRouter.list(),
  router.prescriberAppRouter.structureList(),
  router.prescriberAppRouter.list(),
  router.picoAppRouter.list(),
  router.badgeAppRouter.badges(),
  router.monetAppRouter.listBills(),
  router.monetAppRouter.listBillLabels(),
  router.monetAppRouter.listRegularizations(),
  router.monetAppRouter.listPayments(),
  router.monetAppRouter.listProclientsMembersPaymentsIntents(),
  router.monetAppRouter.listCaregiversPaymentsIntents(),
  router.monetAppRouter.listTaxCreditPaymentRequests(),
  router.monetAppRouter.listThirdPartyPayers(),
  router.compassAppRouter.root(),
  router.metabaseAppRouter.root(),
];

/**
 * List view to land on after an entity change (avoids keeping a previous-entity
 * detail URL). Returns undefined when no list view matches — caller stays put.
 */
export const findClosestRedirectionListView = (pathname: string): string | undefined => {
  return REDIRECTION_LIST_VIEWS.find(listView => pathname.startsWith(listView));
};
